/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_RecordsInputs */

const en_features_progress_records = /** @type {(inputs: Features_Progress_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New bests this month`)
};

const pl_features_progress_records = /** @type {(inputs: Features_Progress_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekordy w tym miesiącu`)
};

/**
* | output |
* | --- |
* | "New bests this month" |
*
* @param {Features_Progress_RecordsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_records = /** @type {((inputs?: Features_Progress_RecordsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_RecordsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_records(inputs)
	return en_features_progress_records(inputs)
});